import React from 'react';

import './quote-carousel-item.styl';

class QuoteCarouselItem extends React.Component {

  render() {
    return (
      <div className={'quote-carousel-item clearfix' + (this.props.hasControls ? ' has-controls' : '')}>
        { this.props.avatar &&
          <img className="quote-carousel-item__avatar z-depth-1" src={ this.props.avatar } alt={ this.props.author } />
        }
        <blockquote className="quote-carousel-item__quote">
          <p className="quote-carousel-item__quote__text">{ this.props.text }</p>
          <span className="quote-carousel-item__quote__author">{ this.props.author }</span>
        </blockquote>
      </div>
    );
  }
}

export default QuoteCarouselItem;



// WEBPACK FOOTER //
// ./src/components/quote-carousel/quote-carousel-item/quote-carousel-item.js